import { useEffect, useState } from 'react';
import { getPageProps } from '@kibt/krn-utils';
import { useHttp } from '@/request';

export function useShowSellTheme() {
    const [showSellBanner, setShowSellBanner] = useState(false);
    const [showSellIcon, setShowSellIcon] = useState(false);

    const bundleId = getPageProps().bundleId;
    const themeStyle = getPageProps().themeStyle;

    const { runAsync: getActivityTime } = useHttp('GET/rest/o/ecommerce/marketing/c/customer/kwai/shop/current/activity', null, {
        manual: true,
        cacheKey: 'activityTime',
    });
    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await getActivityTime({});
                const ifShowBanner = ['IN_PROGRESS'].includes(data?.data?.activityTimeNode);
                // 购物车、提单页大促期间设置navbar
                if (ifShowBanner && themeStyle === '1' && ['MyShoppingCar', 'EcommOrderConfirm'].includes(bundleId)) {
                    setShowSellBanner(true);
                } else {
                    setShowSellBanner(false);
                }

                // 购物车、提单页、订单详情页大促期间商品卡片左上角设置icon
                if (ifShowBanner && ['MyShoppingCar', 'EcommOrderConfirm', 'OrderDetail'].includes(bundleId)) {
                    setShowSellIcon(true);
                } else {
                    setShowSellIcon(false);
                }
            } catch (error) {
                setShowSellBanner(false);
                setShowSellIcon(false);
            }
        };

        // 只有购物车、提单页、订单详情页设置大促换肤
        if (!['MyShoppingCar', 'EcommOrderConfirm', 'OrderDetail'].includes(bundleId)) {
            setShowSellBanner(false);
            setShowSellIcon(false);
        } else {
            // TODO: 需要大促时再打开
            // fetchData();
        }
    }, [bundleId]);

    return {
        showSellBanner,
        showSellIcon,
    };
}
